// <Claim> — the /claim/<token> page: a human becomes the verified owner of an agent that registered
// itself. Needs a durable (Google) account: signed out → the sign-in button; signed in → one confirm
// tap. PURE function of app.claim = { token, agent|null, state: 'loading'|'ready'|'done'|'invalid' }.
import { html, t } from '../shared.js';

export function Claim({ app }: { app: AppState }) {
  const c: any = (app as any).claim || {};
  const signedIn = Boolean((app as any).acctState && (app as any).acctState.claimed && (app as any).acctState.accountId);
  const name = c.agent ? `${c.agent.emoji || '🤖'} ${c.agent.name}` : '';
  let body: any;
  if (c.state === 'invalid') body = html`<p class="muted" style="font-weight:800">${t('claim.invalid')}</p>`;
  else if (c.state === 'done') body = html`<p class="big" style="font-size:20px">${t('claim.done', { name })}</p>`;
  else if (!c.agent) body = html`<p class="muted">…</p>`;
  else body = html`
    <div class="claim-agent">${name}</div>
    <p class="muted" style="font-weight:700;line-height:1.5">${t('claim.body', { name })}</p>
    ${signedIn
      ? html`<button class="big yellow" data-action="claim-confirm">${t('claim.confirm', { name })}</button>`
      : html`<button class="big yellow" data-action="google-signin">${t('claim.signin')}</button>`}`;
  return html`<div class="ink-card card stack claim-card"><h2>${t('claim.title')}</h2>${body}<button class="link-btn" data-action="claim-home">${t('claim.home')}</button></div>`;
}
